import { Link } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import Breadcrumb from '@/components/feature/Breadcrumb';
import useSeo from '@/hooks/useSeo';
import { siteInfo } from '@/mocks/site';

export default function AboutPage() {
  useSeo({
    title: '关于我们 - 51吃瓜网',
    description:
      '了解51吃瓜网的平台定位、内容范围与联系方式。我们聚焦娱乐热点、爆料报道与网络趣闻，致力于提供清晰、易读的娱乐资讯。',
    keywords: '51吃瓜网,关于我们,娱乐资讯平台,内容声明',
  });

  const sections = [
    {
      icon: 'ri-focus-3-line',
      title: '网站定位',
      color: 'primary',
      content: siteInfo.intro,
    },
    {
      icon: 'ri-file-list-3-line',
      title: '内容范围与服务声明',
      color: 'accent',
      content: siteInfo.scope,
    },
  ];

  return (
    <SiteLayout>
      <div className="w-full px-4 md:px-8 py-8 md:py-10">
        <Breadcrumb items={[{ label: '关于我们' }]} />

        <div className="rounded-lg bg-background-100 border border-background-200 p-6 md:p-10 mb-8">
          <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">{siteInfo.name}</h1>
          <p className="mt-2 text-primary-600 font-medium">{siteInfo.slogan}</p>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed max-w-3xl">
            {siteInfo.name} 是一个以实时更新为特色的娱乐资讯平台，我们关注娱乐圈的热点、爆料与趣闻，
            希望让每一位吃瓜群众都能快速、轻松地获取想要了解的内容。
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
          {sections.map((s) => (
            <div key={s.title} className="rounded-lg border border-background-200 bg-background-50 p-6">
              <div className="flex items-center gap-3 mb-4">
                <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                  <i className={`${s.icon} text-xl`} />
                </span>
                <h2 className="font-heading text-lg font-bold text-foreground-950">{s.title}</h2>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{s.content}</p>
            </div>
          ))}
        </div>

        <div className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-8 mb-8">
          <div className="flex items-center gap-3 mb-5">
            <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600">
              <i className="ri-customer-service-2-line text-xl" />
            </span>
            <h2 className="font-heading text-lg font-bold text-foreground-950">联系方式</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="rounded-lg bg-background-100 p-5">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50 text-primary-600 mb-3">
                <i className="ri-mail-line" />
              </span>
              <p className="text-xs text-foreground-400">邮箱</p>
              <p className="mt-1 text-sm text-foreground-800 break-all">{siteInfo.contact.email}</p>
            </div>
            <div className="rounded-lg bg-background-100 p-5">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50 text-primary-600 mb-3">
                <i className="ri-weibo-line" />
              </span>
              <p className="text-xs text-foreground-400">微博</p>
              <p className="mt-1 text-sm text-foreground-800">{siteInfo.contact.weibo}</p>
            </div>
            <div className="rounded-lg bg-background-100 p-5">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50 text-primary-600 mb-3">
                <i className="ri-wechat-line" />
              </span>
              <p className="text-xs text-foreground-400">微信公众号</p>
              <p className="mt-1 text-sm text-foreground-800">{siteInfo.contact.wechat}</p>
            </div>
          </div>
        </div>

        <div className="rounded-lg border border-background-200 bg-background-100 p-6 md:p-8">
          <h2 className="font-heading text-lg font-bold text-foreground-950 flex items-center gap-2 mb-3">
            <span className="w-6 h-6 flex items-center justify-center rounded-md bg-secondary-200 text-secondary-900">
              <i className="ri-shield-check-line text-sm" />
            </span>
            版权及免责声明
          </h2>
          <p className="text-sm text-foreground-600 leading-relaxed">{siteInfo.disclaimer}</p>
          <div className="mt-6">
            <Link
              to="/"
              className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-home-4-line" /> 返回首页
            </Link>
          </div>
        </div>
      </div>
    </SiteLayout>
  );
}